module.exports = __webpack_public_path__ + "media/images/partner-11-c1570ced124c452ae8e21239e3f4ee7a.png";